var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-tag-manager',{attrs:{"list":_vm.tagOptions,"tag-preloader":_vm.tagPreloader,"tags":_vm.tags,"list-value-field":"name"},on:{"attachTag":_vm.attachTag,"detachTag":_vm.detachTag,"storeTag":_vm.testStoreData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }